/**
 * Formata a data conforme o formato fornecido
 * @param {*} DataInicial Data sem formatação
 * @param {*} Formato Formato desejado
 * @returns Data formatada
 */
export const format = ({ DataInicial, Formato }) => {
    if (!DataInicial || !Formato) return undefined;

    function AddZero(Value) {
        return Value.toString().padStart(2, '0');
    }

    let dateObj;

    if (typeof DataInicial === 'string') {
        dateObj = new Date(DataInicial);
        if (isNaN(dateObj)) return undefined;
    } else {
        dateObj = new Date(DataInicial);
    }

    const DD = AddZero(dateObj.getDate());
    const MM = AddZero(dateObj.getMonth() + 1);
    const YYYY = dateObj.getFullYear();
    const HH = AddZero(dateObj.getHours());
    const mm = AddZero(dateObj.getMinutes());
    const ss = AddZero(dateObj.getSeconds());

    const DataFormatada = Formato.replace('DD', DD)
        .replace('MM', MM)
        .replace('YYYY', YYYY)
        .replace('T', ' - ')
        .replace('HH', HH)
        .replace('mm', mm)
        .replace('ss', ss);

    return DataFormatada;
};

/**
 * Adiciona uma certa quantidade de dias, meses ou anos à uma data
 * @param {*} DataInicial Data inicial
 * @param {*} Valor Quantidade a ser acrescida
 * @param {*} FormatoValor D para dia, M para mês e Y para ano
 * @returns Data com acréscimo
 */
export const add = ({ DataInicial, Valor, FormatoValor }) => {
    if (!DataInicial || !Valor || !FormatoValor) {
        return undefined;
    }

    let DataFormatada = new Date(DataInicial);

    switch (FormatoValor) {
        case 'D':
            DataFormatada.setDate(DataFormatada.getDate() + parseInt(Valor, 10));
            break;

        case 'M':
            DataFormatada.setMonth(DataFormatada.getMonth() + parseInt(Valor, 10));
            break;

        case 'Y':
            DataFormatada.setFullYear(DataFormatada.getFullYear() + parseInt(Valor, 10));
            break;

        default:
            DataFormatada = undefined;
            break;
    }

    return DataFormatada;
};

/**
 * Calcula a diferença entre datas
 * @param {*} DataInicial_1 Primeira data
 * @param {*} DataInicial_2 Segunda data
 * @returns Quantidade em dias
 */
export const difference = ({ DataInicial_1, DataInicial_2 }) => {
    if (!DataInicial_1 || !DataInicial_2) {
        return undefined;
    }

    const parseDate = (data) => {
        if (data instanceof Date) return data;
        if (typeof data === 'string') {
            if (data.split('-')[0]?.length === 2 || data.split('/')[0]?.length === 2) {
                data = format({
                    DataInicial: data,
                    Formato: 'YYYY-MM-DD',
                });
            }
            return new Date(data);
        }
        return new Date(data);
    };

    const date1 = parseDate(DataInicial_1);
    const date2 = parseDate(DataInicial_2);

    const diffInTime = date2.getTime() - date1.getTime();

    if (diffInTime < 0) return 0;

    const diffInDays = Math.round(diffInTime / (1000 * 3600 * 24));

    return diffInDays;
};
